export default "__VITE_ASSET__BToAWKRg__"